<template>
  <div style="position: relative; height: 100%; width: 100%">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  props: {
    chartData: {
      type: Array, // Expected: Array of values
      default: () => []
    },
    labels: {
        type: Array,
        default: () => []
    }
  },
  data: () => ({
    chart: null
  }),
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  watch: {
    chartData: {
      handler() {
        if (this.chart) {
            this.chart.destroy();
        }
        this.renderChart();
      },
      deep: true
    }
  },
  methods: {
    renderChart() {
      const ctx = this.$refs.canvas.getContext("2d");

      this.chart = new Chart(ctx, {
        type: "line",
        data: {
          labels: this.labels,
          datasets: [
            {
              data: this.chartData,
              borderColor: '#FF4600',
              borderWidth: 4,
              backgroundColor: 'rgba(255, 70, 0, 0.05)', // 5% opacity fill
              pointRadius: 0, // No points
              lineTension: 0.4, // Smooth curve
              fill: true
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          tooltips: {
              enabled: true,
              mode: 'index',
              intersect: false,
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
                drawBorder: false
              },
              ticks: {
                  fontColor: '#9ca3af',
                  fontSize: 10,
                  maxTicksLimit: 12
              }
            }],
            yAxes: [{
                display: true,
                gridLines: {
                    display: true,
                    color: '#f3f4f6', // Very light gray
                    borderDash: [5, 5], // Dotted/Dashed effect if needed, or solid light
                    drawBorder: false,
                    zeroLineColor: '#f3f4f6'
                },
                ticks: {
                    beginAtZero: false, // Image shows 11.000 starting point
                    fontColor: '#9ca3af',
                    fontSize: 10,
                    padding: 10,
                    callback: function(value) {
                        return value.toLocaleString('pt-BR'); // 11.000 format
                    }
                }
            }]
          }
        }
      });
    }
  }
};
</script>
